// Path: ./src/contextApi/context.ts
import React from "react";
import { GoFlyerAdminState, initialGoFlyerAdminState } from "./state";
import { GoFlyerAdminActions } from "./actions";

export const GoFlyerAdminContext = React.createContext<{
  state: GoFlyerAdminState;
  dispatch: React.Dispatch<GoFlyerAdminActions>;
}>({
  state: initialGoFlyerAdminState,
  dispatch: () => undefined,
});
